export default function gtmClickEvent(event: "click_item", data: unknown) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, data });
}
